//TODO: Remove once we figure out what "CollectionReviews" component is
export const getHost = (env, host) => {
  const clientHost = 'https://www.homedepot.com';
  const serverDefaultHost = 'https://api.edge-pr.homedepot.com';
  const devHost = 'https://hd-qa71.homedepotdev.com';
  const devServer = 'https://api.edge-dev.homedepot.com';
  const stageHost = 'https://hd-qa74.homedepotdev.com';
  const stageServer = 'https://api.edge-stage.homedepot.com';
  const betaServer = 'https://api-beta.edge-pr.homedepot.com';

  const runtime = host || typeof window !== 'undefined'
    ? 'client'
    : 'server';

  switch (`${env}:${runtime}`) {
    case 'prod:client':
      return clientHost;
    case 'prod:server':
      return serverDefaultHost;
    case 'prod-beta:client':
      return clientHost;
    case 'prod-beta:server':
      return betaServer;
    case 'dev:client':
      return devHost;
    case 'dev:server':
      return devServer;
    case 'stage:client':
      return stageHost;
    case 'stage:server':
      return stageServer;
    default:
      return clientHost;
  }
};

export const getBazaarVoiceHost = ({ env }) => {
  const prodHost = 'https://api.bazaarvoice.com';
  const stageHost = 'https://stg.api.bazaarvoice.com';

  switch (env) {
    case 'prod':
      return prodHost;
    default:
      return stageHost;
  }
};
